import { Badge } from "react-bootstrap";

const renderStatus = (status) => {
  switch(status) {
    case "Success":
      return <Badge pill bg="success">{status}</Badge>;
    case "Warning":
      return <Badge pill bg="warning">{status}</Badge>;
    default:
      return <Badge pill bg="danger">{status}</Badge>;
  }
}

export { renderStatus };